<main class="navigation-section-page">
    <ng-container [ngSwitch]="!!data?.displayLeftNavigation">
        <section class="page-grid-content--with-left-navigation layout-wrapper" *ngSwitchCase="true" >
            <app-side-navigation class="page-grid-content__left-navigation"></app-side-navigation>
            <app-spot-grid [grid]="data?.mainGrid" class="page-grid-content"></app-spot-grid>
        </section>

        <section class="page-grid-content" *ngSwitchCase="false">
            <app-spot-grid [grid]="data?.mainGrid" *ngIf="data?.mainGrid"></app-spot-grid>
        </section>
    </ng-container>
</main>